import { ShareToolFilter } from '@/views/SavedQueries/types';

export const SHARE_TOOL_TYPE_TO_ICON_NAME_MAP: Record<ShareToolFilter, string> =
  {
    SLACK: 'slack',
    EMAIL: 'mail',
    GOOGLE: 'google-sheets',
    S3_BUCKETS: 's3',
    ZAPIER: 'zapier',
  };
